// extracted by mini-css-extract-plugin
export default {"container":"TaxYearEvents_container__6ZEj5","table":"TaxYearEvents_table__8fXD-"};